import React, { useState } from 'react'

import { CustomTheme } from '@masfront/common-b2c'

import { Drawer, Box } from '@material-ui/core'
import { createStyles, makeStyles } from '@material-ui/core/styles'
import CloseIcon from '@material-ui/icons/Close'
import ShoppingCartIcon from '@material-ui/icons/ShoppingCart'
import SpeedDial from '@material-ui/lab/SpeedDial'
import SpeedDialIcon from '@material-ui/lab/SpeedDialIcon'

const useStyles = makeStyles(({ transitions, breakpoints, palette, name }: CustomTheme) =>
  createStyles({
    transition: {
      transition: transitions.create('transform', {
        easing: transitions.easing.sharp,
        duration: transitions.duration.enteringScreen,
      }),
    },
    paperOpen: {
      height: 'calc(100vh - 56px)',
      position: 'relative',
      transform: 'translateX(0px)',
      backgroundColor: name === 'llamaya' ? palette.primary.main : palette.grey[800],
      overflow: 'hidden',
      overflowY: 'auto',
      [breakpoints.down('md')]: {
        overflow: 'hidden',
        '&.opened': {
          transform: 'translateX(0px)',
          overflow: 'auto',
        },
      },
    },
    drawerOpen: {
      zIndex: 3,
      backgroundColor: name === 'llamaya' ? palette.primary.main : palette.grey[800],
      [breakpoints.down('md')]: {
        transform: 'translateX(250px)',
        overflow: 'hidden',
        '&.opened': {
          transform: 'translateX(0px)',
          overflow: 'auto',
        },
      },
    },
    icon: {
      width: '24px',
      cursor: 'pointer',
      '& > .MuiFab-root': {
        width: '30px',
        height: 'auto',
        color: palette.grey[50],
        backgroundColor: name === 'llamaya' ? palette.primary.main : palette.grey[800],
        boxShadow: 'none',
      },
    },
    sidebarWrapper: {
      [breakpoints.down('md')]: {
        transform: 'translateX(65px)',
        marginTop: '0px',
        '&.opened': {
          transform: 'translateX(0px)',
        },
      },
    },
    iconsWrapper: {
      transform: 'translateX(-255px)',
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'flex-end',
      '&.opened': {
        transform: 'translateX(0px)',
      },
      [breakpoints.up('lg')]: {
        display: 'none',
      },
    },
  }),
)

export default function SidebarWrap({ children }: { children: React.ReactNode }) {
  const classes = useStyles()
  const [isOpen, setIsOpen] = useState(false)

  const openClass = isOpen ? 'opened' : ''

  return (
    <Drawer
      anchor="right"
      variant="permanent"
      className={`${classes.drawerOpen} ${classes.transition} ${openClass}`}
      classes={{
        paper: `${classes.paperOpen} ${classes.transition} ${openClass}`,
      }}
    >
      <Box mr="12px" className={`${classes.iconsWrapper} ${classes.transition} ${openClass}`}>
        <SpeedDial
          ariaLabel="SpeedDial openIcon example"
          className={classes.icon}
          icon={<SpeedDialIcon icon={<ShoppingCartIcon />} openIcon={<CloseIcon />} />}
          onClick={() => setIsOpen(!isOpen)}
          open={isOpen}
        />
      </Box>

      <Box className={`${classes.sidebarWrapper} ${classes.transition} ${openClass}`}>
        {children}
      </Box>
    </Drawer>
  )
}
